import styled from "styled-components";

export const StyledContainer = styled.section<{ $isVisible: boolean }>`
  height: 100%;
  left: 0;
  opacity: 1;
  overflow: hidden;
  position: fixed;
  top: 0;
  transition: opacity 0.5s ease-in-out 0.5s;
  width: 100%;
  z-index: 200000000;
  background-color: white;
  display: ${({ $isVisible }) => ($isVisible ? "flex" : "none")};
  justify-content: center;
  align-items: center;

  & h2 {
    font-family: ThemeFontRegular;
  }
`;

export const Content = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Video = styled.video`
  background-color: #ffffff;
  display: inline-block;
`;

export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 0 16px;
`;

export const Message = styled.h2`
  font-family: ThemeFontRegular;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0;
  text-align: center;
`;

export const Text = styled.p`
  font-family: ThemeFontRegular;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0;
  text-align: center;
`;
